import { Component, OnInit, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'resource-column',
  templateUrl: './resource-column.component.html',
  styleUrls: ['./resource-column.component.css']
})
export class ResourceColumnComponent implements OnInit {
  @Input() keys:string[];
  @Input() sets:any;
  @Input() currentSet:string;
  constructor() { }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/resource-column/resource-column.component.ts